import TrashCan from '../../src/legacy/TrashCan.tsx';
export default TrashCan;
